module.exports = __webpack_public_path__ + "img/open-full-screen.e538beab.svg";